import {
  GoogleCloudConnectionContext,
  type IGoogleCloudConnectionContext,
} from "@via/context/google-cloud-connection-context.tsx";
import { useContext } from "react";

export function useGoogleCloudConnection(): IGoogleCloudConnectionContext {
  return useContext(GoogleCloudConnectionContext);
}
